// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PriorityMessageView/styles.scss
// module id = 1065
// module chunks = 0